import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    width: '82%',
    padding: '3% 3%',
    margin: 'auto',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '20px',
    color: '#666666',
    marginBottom: 7,
  },
  subtitle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '18px',
    margin: '0px 16px',
    color: '#666666',
  },
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'capitalize',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    marginBottom: 0,
    marginTop: '16px',
    marginRight: 0,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  tableBody: {
    backgroundColor: '#ffffff',
    border: '1px solid #CCCCCC',
  },
  autocomplete: {
    padding: '0px',
    width: '20%',
  },
  heading: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px',
    color: '#666666',
  },
  accordion: {
    margin: '0px !important',
    borderTop: '2px solid #ECECEC',
  },
  container: {
    margin: '24px auto',
    width: '80%',
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '18px',
    color: '#666666',
  },
  wagonDetail: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: '#666666',
    textTransform: 'capitalize',
  },
  wagonNumberStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 20,
    lineHeight: '28px',
    color: '#DF0C36',
  },
  statusStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '20px',
    color: '#2ECC71',
    textTransform: 'capitalize',
  },
  warningStatusStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '20px',
    color: '#F39C12',
    textTransform: 'capitalize',
  },
  deletedStatusStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '20px',
    color: '#DF0C36',
    textTransform: 'capitalize',
  },
  gridMargin: {
    margin: '15px !important',
  },
  secondaryHeading: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '18px',
    color: '#CCCCCC',
    marginTop: 6,
    marginRight: 46,
    right: 0,
    position: 'absolute',
  },
  expandIcon: {
    color: '#DF0C36',
  },
  accordionDetails: {
    display: 'block',
  },
  button: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  collapseButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '18px',
    marginTop: '20px',
    color: '#DF0C36',
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  expandButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '18px',
    marginTop: '20px',
    color: '#666666',
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  endOfAppBarStyle: {
    borderBottom: '3px solid #DF0C36',
  },
  totalDiv: {
    display: 'flex',
    border: '1px solid #CCCCCC',
    height: 52,
    alignItems: 'center',
  },
  totalAmount: {
    float: 'right',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '20px',
    color: '#000000',
    margin: '0 12px',
    whiteSpace: 'nowrap',
  },
  totalLabel: {
    width: 200,
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 16,
    lineHeight: '24px',
    color: '#000000',
    margin: '0 12px',
  },
  addButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    backgroundColor: '#DF0C36',
    color: 'white',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '29%',
    marginRight: '3%',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: '#DF0C36',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 25px white',
    },
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
}));
